import { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

function EdwinDialog({
  open,
  setOpen,
  body,
  title,
}: {
  open?: boolean;
  setOpen: React.Dispatch<boolean>;
  body: React.ReactNode;
  title?: string;
}) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog className="relative z-10" onClose={() => setOpen(false)}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel className="sh-dialog relative max-h-[90vh] max-w-[90vw] transform rounded-lg bg-white shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl">
                <div className="flex w-full items-center justify-between p-6 pb-0">
                  <h1 className="mb-2 font-cadiz text-sh-xs font-bold">{title || 'Terms and conditions'}</h1>
                  <XMarkIcon className="h-6 w-6 cursor-pointer text-primary-600" onClick={() => setOpen(false)} />
                </div>
                <div className="scroll-thin-sh max-h-[75vh] overflow-y-auto whitespace-pre-wrap p-6">{body}</div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default EdwinDialog;
